<template>
  <div>
    <SidebarSearch @submit="submitForm" @clear="clearForm">
      <span>Atendimentos em Andamento?</span>
        <toogleswitch
          style="margin-top: 10px;"
          v-model="statusValue"
          label="Atendimento em Andamento"
          @change="onToggleChange"
        />
      <SearchCollapse :expanded="true" title="Dados Gerais">
        <NxInputName @update:value="handleInputUpdate('name', $event)" />
        <NxInputClientWApp @update:value="handleInputUpdate('identifier', $event)" />
        <NxInputProtocolsWApp @update:value="handleInputUpdateArray('protocols', $event)" />
      </SearchCollapse>
      <SearchCollapse title="Instituição">
        <NxSelectPAAtendimento @update:value="handleSelectUpdate('deptoId', $event)" />
      </SearchCollapse>
      <SearchCollapse title="Responsável">
        <NxSelectResponsavelAtendimento @update:value="handleSelectUpdate('operatorId', $event)" />
      </SearchCollapse>
      <SearchCollapse title="Geral">
        <div>
          <NxSelectTipoFinalizacao @update:value="handleSelectUpdate('typeFinalization', $event)" />
          <NxInputDateRangeAtendimento
            :limitToFifteenDays="true"
            label="Período de Referência:"
            @update:InitialValue="handleInputDateUpdate('startDate', $event, false)"
            @update:FinalValue="handleInputDateUpdate('endDate', $event, false)"
          />
        </div>
      </SearchCollapse>
    </SidebarSearch>
  </div>
</template>

<script>
import SidebarSearch from '@/containers/layout/sidebars/SidebarSearch.vue'
import SearchCollapse from '@/containers/layout/sidebars/components/SearchCollapse.vue'
import { NxSelectPAAtendimento, NxSelectTipoFinalizacao, NxSelectResponsavelAtendimento } from '@/components/nexum/components/custom-selects/index.js'
import { NxInputName, NxInputClientWApp, NxInputDateRangeAtendimento, NxInputProtocolsWApp } from '@/components/nexum/components/custom-inputs/index.js'
import toogleswitch from '@/components/UI/toogleSwitch/toogleSwitch.vue'

export default {
  name: 'SidebarQuadro',
  components: { SidebarSearch, SearchCollapse, NxSelectPAAtendimento, NxInputName, NxInputClientWApp, NxSelectTipoFinalizacao, toogleswitch, NxSelectResponsavelAtendimento, NxInputDateRangeAtendimento, NxInputProtocolsWApp },
  data () {
    return {
      form: {
        name: null,
        deptoId: null,
        identifier: null,
        typeFinalization: null,
        startDate: null,
        endDate: null,
        operatorId: null,
        page: 1,
        pageSize: 10,
        status: 'Finalizado',
        protocols: null
      }
    }
  },
  computed: {
    statusValue: {
      get () {
        return this.form.status === 'Aberto'
      },
      set (value) {
        this.form.status = value ? 'Aberto' : 'Finalizado'
      }
    }
  },
  methods: {
    submitForm () {
      this.$nextTick(() => {
        this.$emit('search', this.form)
        this.$emit('update-pagination')
      })
    },
    clearForm () {
      this.$root.$emit('clearForm')
      this.$nextTick(() => {
        this.submitForm()
        this.page = 1
      })
    },
    clearField (field) {
      this.form[field] = null
    },
    handleSelectUpdate (fieldName, selectedValue) {
      if (typeof selectedValue === 'string' || typeof selectedValue === 'number') {
        this.form[fieldName] = [selectedValue]
        return
      }
      if (Array.isArray(selectedValue) && !selectedValue.length) {
        this.clearField(fieldName)
        return
      }
      if (selectedValue) {
        this.form[fieldName] = Array.isArray(selectedValue) ? selectedValue.map(v => v.value) : [selectedValue.value]
      } else {
        this.clearField(fieldName)
      }
    },
    handleInputUpdate (fieldName, inputedValue) {
      if (inputedValue) {
        this.form[fieldName] = inputedValue.replace(/[^a-zA-Z0-9 ]/g, '')
      } else {
        this.clearField(fieldName)
      }
    },
    handleInputUpdateArray (fieldName, inputedValue) {
      if (inputedValue) {
        this.form[fieldName] = [inputedValue]
      } else {
        this.clearField(fieldName)
      }
    },
    handleInputDateUpdate (fieldName, inputedValue) {
      if (inputedValue) {
        this.form[fieldName] = new Date(inputedValue).toISOString()
      } else {
        this.clearField(fieldName)
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/private/atendimento/relatorios_atendimento/search/SidebarRelatorioAtendimento.vue